export default "/assets/website/images/store-4.jpeg?7b12d74453da5ae7b77b7ddce11c6278";